import axios from "axios";
import {
  requestConfig,
  requestErrorHandler,
  responseConfig,
  responseErrorHandler,
} from "./interceptor";
const baseURL = process.env.REACT_APP_BASE_API_URL;

const axiosConfig = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosConfig.interceptors.request.use(requestConfig, requestErrorHandler);

// Response interceptor
axiosConfig.interceptors.response.use(responseConfig, responseErrorHandler);

export default axiosConfig;
